import { ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export default function useUserTags() {
  const { authUser } = useAuthUser();
  const userTags = ref<string[]>([]);

  const userTagsUpdateData = async (tags: string[]) => {
    if (!authUser.value) {
      throw new Error("There is no authorized user");
    }
    const data: { fields: any } = { fields: { tags } };
    data.fields.userId = authUser.value.id;
    const result = await providers.QuestionaryInfoProvider.update({ data });
    userTags.value = (result.fields.tags as any as number[]).map(t => t.toString());
  };
  const userTagsGetData = async () => {
    if (!authUser.value) {
      throw new Error("There is no authorized user");
    }
    const result = await providers.QuestionaryInfoProvider.find({ id: authUser.value.id });
    userTags.value = (result.fields.tags as any as number[]).map(t => t.toString());
  };

  return { userTags, userTagsUpdateData, userTagsGetData };
}
